var _path, _path2, _rect, _rect2, _path3, _path4, _circle, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsufficientBudget(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 216,
    viewBox: "0 0 103 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6168 192.043L20.6769 174.821C19.7649 174.343 19.1348 173.399 19.1348 172.299V152.308C19.1348 151.257 19.9877 150.404 21.0386 150.404C21.387 150.404 21.6973 150.524 21.9791 150.688L51.5002 168.361V192.289C51.1746 192.289 50.8833 192.186 50.6168 192.043Z",
    fill: "#FFD217"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3834 192.043L82.3233 174.821C83.2352 174.343 83.8654 173.399 83.8654 172.299V152.308C83.8654 151.257 83.0125 150.404 81.9616 150.404C81.6132 150.404 81.3028 150.524 81.0211 150.688L51.5 168.361V192.289C51.8256 192.289 52.1168 192.186 52.3834 192.043Z",
    fill: "#FEB705"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    width: 15.2308,
    height: 169.442,
    fill: "#FEB705"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.2695,
    width: 15.2308,
    height: 169.442,
    fill: "#FFD217"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 36.1743C24.1619 36.1743 1.99997 58.3362 1.99997 85.6743C1.99997 113.012 24.1619 135.174 51.5 135.174",
    stroke: "#FFD217",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 135.174C78.8381 135.174 101 113.012 101 85.6739C101 58.3357 78.8381 36.1738 51.5 36.1738",
    stroke: "#FEB705",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5005,
    cy: 85.6728,
    r: 47.5962,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8123 60.9229H68.7495V67.3699H40.8123V60.9229ZM34.3652 71.6679H68.7495V78.115H34.3652V71.6679Z",
    fill: "#192643"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.909 91.0091H44.0358C51.8174 91.0091 60.1534 84.9639 60.1534 75.966C60.1534 66.968 51.8174 60.9229 44.0358 60.9229H34.3652V67.3699H44.0358C48.091 67.3699 53.7064 70.3592 53.7064 75.966C53.7064 81.5727 48.091 84.562 44.0358 84.562H34.3652V91.4453L57.0567 110.35H67.1227L43.909 91.0091Z",
    fill: "#192643"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsufficientBudget);
export default __webpack_public_path__ + "static/media/insufficient_budget.a3a5ed32c78f3ecdab69419825805971.svg";
export { ForwardRef as ReactComponent };